<template>
  <page-layout
    :header="isMobile"
    :loaded="currentUserLoaded"
    class="home-page"
    title="Home"
  >
    <div class="home-tabs-wrapper">
      <v-tabs
        v-model="activeTab"
        class="home-tabs"
        background-color="transparent"
        color="primary"
        :centered="!isMobile"
      >
        <v-tab v-for="tab in tabs" :key="tab.id" class="home-tab">
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.label }}
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items
      v-model="activeTab"
      class="home-tabs-content"
      :touchless="true"
    >
      <v-tab-item
        v-for="tab in tabs"
        :key="tab.id"
        :transition="false"
        :reverse-transition="false"
      >
        <component :is="tab.component" />
      </v-tab-item>
    </v-tabs-items>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex';

import HomeWelcomeTab from './HomeWelcomeTab.vue';
import HomeCyAiTab from './HomeCyAiTab.vue';
import HomeRecruitTab from './HomeRecruitTab.vue';
import HomeOnboardTab from './HomeOnboardTab.vue';
import HomeTrainTab from './HomeTrainTab.vue';
import HomeRetainTab from './HomeRetainTab.vue';

export default {
  name: 'HomeView',
  components: {
    HomeWelcomeTab,
    HomeCyAiTab,
    HomeRecruitTab,
    HomeOnboardTab,
    HomeTrainTab,
    HomeRetainTab,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    tabs() {
      return [
        {
          id: 'welcome',
          label: 'Welcome',
          icon: 'mdi-home-outline',
          component: 'HomeWelcomeTab',
        },
        {
          id: 'cy-ai',
          label: 'Cy AI',
          icon: 'mdi-robot-outline',
          component: 'HomeCyAiTab',
        },
        {
          id: 'recruit',
          label: 'Recruit',
          icon: 'mdi-account-search-outline',
          component: 'HomeRecruitTab',
        },
        {
          id: 'onboard',
          label: 'Onboard',
          icon: 'mdi-clipboard-check-outline',
          component: 'HomeOnboardTab',
        },
        {
          id: 'train',
          label: 'Train',
          icon: 'mdi-school-outline',
          component: 'HomeTrainTab',
        },
        {
          id: 'retain',
          label: 'Retain',
          icon: 'mdi-heart-outline',
          component: 'HomeRetainTab',
        },
      ];
    },
    ...mapGetters('users', ['currentUser', 'currentUserLoaded', 'isAdmin']),
  },
};
</script>

<style lang="less">
.home-page {
  .home-tabs-wrapper {
    display: none; // TODO: Remove this once tabs are ready to be revealed
    padding: 0 20px;
    border-bottom: 1px solid var(--v-darkGray-base);
  }

  .home-tabs {
    max-width: 900px;
    margin: 0 auto;

    .v-tabs-bar {
      height: 48px;
    }

    .home-tab {
      text-transform: none;
      font-weight: 500;
      letter-spacing: 0;
      min-width: 100px;

      .v-icon {
        margin-right: 6px;
      }
    }

    .v-tab--active {
      color: var(--v-primary-base);
    }
  }

  .home-tabs-content {
    background-color: transparent;
  }

  .field-block + .field-block {
    margin-top: 42px;
  }

  .item-card:not(.link-card) {
    background-color: #fff;
    cursor: default;

    &:hover {
      box-shadow: @content-shadow;
      background-color: #fff;

      .content-line,
      .item-card__content {
        background-color: #fff;
      }
    }
  }

  .item-card__content {
    .content-list {
      margin-top: -8px;
    }
  }

  a:hover {
    text-decoration: none;
  }
}
</style>
